import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { useComponentBounds } from 'hooks/useComponentBounds'
import { useWindowSize } from 'hooks/useWindowSize'
import Condition from 'components/Condition'
import { Typography } from '@mui/material'
import Box from 'components/Box'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()({
  container: {
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapper: {
    textAlign: 'center',
  },
  children: {
    textAlign: 'center',
  },
})

const PageLoadingIndicator = ({ style, children }: { style?: React.CSSProperties, children?: React.ReactNode }) => {
  const { classes } = useStyles()
  const { bounds, boundsRef } = useComponentBounds<HTMLDivElement>()
  const { innerHeight } = useWindowSize()
  const minHeight = 96
  const maxHeight = Math.min(innerHeight * 0.8, 480)

  return (
    <div
      ref={boundsRef}
      className={classes.container}
      style={{ height: Math.max(minHeight, Math.min(bounds.width, maxHeight)) }}
      data-cy="loading-page"
    >
      <div className={classes.wrapper}>
        <CircularProgress size={90} thickness={2} style={style} />

        <Condition condition={React.Children.count(children) > 0}>
          <Box>
            <Typography variant="subtitle1">
              <div className={classes.children}>
                {children}
              </div>
            </Typography>
          </Box>
        </Condition>
      </div>
    </div>
  )
}

export default React.memo(PageLoadingIndicator)
